import React from 'react';

import { CLASS_TYPES } from '@classCreation/data/classTypes';
import Select from 'components/Select';

export default function ClassTypeSelect(props) {
  const options = Object.values(CLASS_TYPES).map((classType) => ({
    label: classType,
    value: classType,
  }));

  return (
    <Select
      options={options}
      {...props}
    />
  );
}
